import { render, staticRenderFns } from "./LegacyEmptyTableMessageComponent.vue?vue&type=template&id=7f7f8099&"
import script from "./LegacyEmptyTableMessageComponent.vue?vue&type=script&lang=ts&"
export * from "./LegacyEmptyTableMessageComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f7f8099')) {
      api.createRecord('7f7f8099', component.options)
    } else {
      api.reload('7f7f8099', component.options)
    }
    module.hot.accept("./LegacyEmptyTableMessageComponent.vue?vue&type=template&id=7f7f8099&", function () {
      api.rerender('7f7f8099', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/models/Table/Legacy/LegacyEmptyTableMessageComponent.vue"
export default component.exports